<template>
  <VAutocomplete
    v-model="site"
    :label="$t('forms.labels.site')"
    :items="displayedSites"
    :rules="{ required: true }"
    :loading="loading"
    cacheItems
    returnObject
    @search="debouncedSiteSearch"
    @input="updateData"
  />
</template>

<script>
import { debounce } from 'lodash';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VAutocomplete,
    },
    props: {
        clientId: {
            type: String,
            default: '',
        },
        memberId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            sites: [],
            site: null,
            associatedSites: [],
            loading: false,
            debouncedSiteSearch: debounce(this.searchSites, 500),
        };
    },
    computed: {
        displayedSites() {
            return this.sites.map(site => ({
                name: `${site.name}`,
                id: site.id,
                disabled: this.isSiteAssociated(site.id),
            }));
        },
        associatedSitesById() {
            return this.associatedSites.reduce((associatedSitesById, associatedSite) => ({
                ...associatedSitesById,
                [associatedSite.id]: associatedSite.id,
            }), {});
        },
        isSiteAssociated() {
            return siteId => siteId in this.associatedSitesById;
        },
    },
    async created() {
        this.associatedSites = await this.getMemberSites();
        this.sites = await this.getClientSites();
    },
    methods: {
        async searchSites(search) {
            this.loading = true;
            this.sites = await this.getClientSites(search);
            this.loading = false;
        },
        async getClientSites(search) {
            const { data } = await this.$rq.getClientSites(this.clientId, { search, perpage: 100 });
            return data.sites;
        },
        async getMemberSites() {
            const { data } = await this.$rq.getMemberSites(this.memberId, { onlyExplicit: true });
            return data;
        },
        updateData() {
            this.$emit('sendData', this.site);
        },
    },
};
</script>
